export default "__VITE_ASSET__xGlm3awF__ 700w, __VITE_ASSET__nktv2ECr__ 500w";